import { ExternalLink, PhoneOutgoing } from "@aircall/react-icons";

import { Section, SectionHeader, SectionTitle } from "@/blocks/Section";

import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle";

function OutboundWithCallback() {
  return (
    <Section data-test="call-type-section">
      <SectionHeader>
        <SectionTitle>Call type</SectionTitle>
      </SectionHeader>
      <div className="flex items-center gap-2">
        <PhoneOutgoing className="size-4 text-info" />
        <span className="text-sm font-medium">Outbound</span>
      </div>
      <div className="flex items-center gap-2">
        <span className="text-sm font-medium text-muted-foreground">
          Callback from
        </span>
        <a
          data-test="open-call-timeline-anchor"
          className="inline-flex items-center gap-[2px] text-sm font-medium text-primary hover:underline"
          target="_blank"
          href="https://dashboard.example.com/calls/cb-456/timeline"
          rel="noreferrer"
        >
          Callback request
          <ExternalLink className="size-[18px]" />
        </a>
      </div>
    </Section>
  );
}

export function PlaygroundSectionCallType() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Outbound with callback
        </PlaygroundSubSectionTitle>
        <OutboundWithCallback />
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
